import { useContext } from "react";
import { StaticTextRenderer } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/RichText/StaticTextRenderer";
import type { TextRendererProps } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/RichText/TextRenderer.types";
import { BuilderUIContext } from "@circle-react-shared/BuilderUI/Provider/BuilderUIProvider";
import { VisualEmailTextRenderer } from "./VisualEmailTextRenderer";

export const TextRenderer = (props: TextRendererProps) => {
  const builderContext = useContext(BuilderUIContext);
  return builderContext ? (
    <VisualEmailTextRenderer {...props} />
  ) : (
    <StaticTextRenderer {...props} />
  );
};
